import { render } from "./burger-bar.vue?vue&type=template&id=81a54094"
import script from "./burger-bar.vue?vue&type=script&lang=js"
export * from "./burger-bar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__